<template>
  <div class="p-search">
    <div class="g-header">
      <search-bar :tabs="searchTypes" ref="searchBar" :loading="loading" :show-sort="true" @change="changeHandle">
        <i @click="$router.push({ path: '/' })" class="el-icon-arrow-left" slot="prepend"> 返回</i>
      </search-bar>
    </div>
    <div :class="['scroll-body', (ats.length || reply.id) && 'has-edit']">
      <a :href="advert.link" target="_blank" class="ad-box" v-if="advert">
        <img :src="advert.url" alt="" />
      </a>
      <template v-if="totalCount === 0 && !loading">
        <el-divider>暂无更多消息</el-divider>
      </template>
      <ul class="infinite-list">
        <li v-for="item in messageList" :key="item.msgId">
          <message
            :hide-btns="item.tags ? ['at', 'expand'] : ['reply', 'expand']"
            :is-top="orderby === '' && item.isTop"
            :info="item"
            :types="types"
            :keyword="keyword"
            @click-btn="messageClickHandle"
          ></message>
        </li>
      </ul>
      <el-divider v-if="totalCount && totalCount <= this.messageList.length && !loading">暂无更多信息</el-divider>
    </div>
    <div class="g-footer">
      <edit-box v-if="reply.id || ats.length" :reply.sync="reply" :ats.sync="ats" :types="[]" @send="sendMessage"></edit-box>
    </div>
  </div>
</template>
<script>
import SearchBar from "@/components/SearchBar";
import Chat from "@/api/chat";
import Message from "@/components/Message";
import EditBox from "@/components/EditBox";
import Bus from "@/components/Bus";
import User from "@/api/user";
import Tags from "@/components/tags";
import Utils from "@/utils";
export default {
  data() {
    return {
      ats: [],
      reply: { id: "", txt: "" },
      pageSize: 20,
      pageIndex: 0,
      totalCount: 0,
      loading: false,
      keyword: "",
      tags: "",
      orderby: "",
      hasChange: false,
      messageList: [],
      msgIdList: [],
      info: {}
    };
  },
  components: { SearchBar, Message, EditBox },
  computed: {
    types() {
      const types = [];
      Tags.map(item => types.push(item));
      types.push({
        label: "红包",
        value: "redEnvelope",
        color: "#e74c3c"
      });
      return types;
    },
    searchTypes() {
      const searchTypes = [
        {
          label: "全部",
          value: ""
        }
        // {
        //   label: "@Ta",
        //   value: "AT"
        // }
      ];
      Tags.map(item => searchTypes.push(item));
      searchTypes.push({
        label: "红包",
        value: "redEnvelope",
        color: "#e74c3c"
      });
      return searchTypes;
    },
    searchType() {
      return this.searchTypes.find(item => item.label === this.tags);
    },
    advert() {
      return this.$store.state.advert;
    },
    token() {
      return this.$store.state.token;
    }
  },
  watch: {
    token: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.searchFromUrl();
        }
      }
    }
  },
  methods: {
    back() {
      if (this.hasChange === true) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.go(-1);
      }
    },
    scrollHandle() {
      if (Utils.inBottom() && !this.loading) {
        if (this.messageList.length < this.totalCount) {
          this.more();
        }
      }
    },
    changeHandle(e) {
      this.hasChange = true;
      this.keyword = e.keyword || "";
      const searchType = this.searchTypes.find(item => item.label === e.tab);
      this.tags = searchType.label;
      this.orderby = e.orderby;
      this.pageIndex = 1;
      this.messageList = [];
      this.msgIdList = [];
      this.totalCount = -1;
      this.loading = false;
      this.reply = { id: "", txt: "" };
      this.getMessageList();
      this.$router.push({
        path: "/search",
        query: {
          keyword: this.keyword,
          type: searchType.value
        }
      });
    },
    getUserInfo() {
      const { id } = this.$route.query;
      User.info(id).then(res => {
        this.info = {
          id: res.UserGuid,
          company: res.CompanyName,
          avatar: res.UserAvatarUrl,
          name: res.UserName
        };
      });
    },
    messageClickHandle(e) {
      if (e.type === "at") {
        const findItem = this.ats.find(item => item.id === e.info.id);
        !findItem && this.ats.unshift({ id: e.info.id, name: e.info.name });
      }
      if (e.type === "reply") {
        this.reply = {
          id: e.info.msgId,
          txt: e.info.txt
        };
      }
    },
    searchFromUrl() {
      const { type, keyword, id } = this.$route.query;
      this.info.id = id;
      this.searchTypes.find(item => {
        if (type === item.value) {
          this.tags = item.label;
        }
      });
      this.tags = this.tags || "全部";
      this.keyword = keyword || "";
      this.getMessageList();
    },
    sendMessage(message) {
      Bus.$emit("sendMessage", message);
    },
    more() {
      this.pageIndex += 1;
      this.getMessageList();
    },
    async getMessageList() {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      const postData = {
        pageIndex: this.pageIndex,
        keyword: this.keyword,
        orderby: this.orderby
      };
      if (this.tags === "@Ta") {
        postData.searchType = "AT";
      } else if (this.tags === "全部") {
        postData.tags = "";
      } else if (this.tags) {
        postData.tags = this.tags;
      }
      const messageList = await Chat.search(postData)
        .then(res => {
          const list = [];
          this.totalCount = res.TotalCount;
          res.ResultList.map(item => {
            item.time = this.$timeFormat(item.t);
            list.push(item);
          });
          return list;
        })
        .catch(() => (this.loading = false));
      messageList &&
        messageList.map(item => {
          if (!this.msgIdList.includes(item.msgId)) {
            this.messageList.push(item);
            this.msgIdList.push(item.msgId);
          }
        });
      this.$nextTick(() => (this.loading = false));
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandle, true);
  },
  mounted() {
    this.$store.dispatch("getAdvert");
    window.addEventListener("scroll", this.scrollHandle, true);
  }
};
</script>
<style lang="scss">
.p-search {
  .el-page-header__left {
    align-items: center;
  }
  ul {
    li {
      border-bottom: 1px solid #eee;
    }
    .m-message {
      padding: 0 10px;
    }
    li:last-child {
      border-bottom: none;
    }
  }
  .info-box {
    display: flex;
    font-size: 12px;
    align-items: center;
    height: 40px;
    .el-avatar {
      width: 30px;
      height: 30px;
    }
    .text {
      padding-left: 10px;
      display: inline-block;
      font-size: 14px;
      line-height: 16px;
    }
  }
  .tag-box {
    padding: 10px;
  }
  .context {
    position: relative;
    .time {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 12px;
      color: #999;
    }
  }
  .scroll-body {
    position: relative;
    padding-top: 62px;
    height: 100%;
    overflow: auto;
  }
  .has-edit {
    padding-bottom: 90px;
  }
  .ad-box {
    display: inline-block;
    width: 100%;
    height: 80px;
    margin-bottom: 8px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
